<template>
  <div class="main">
    <div class="content">
      <div class="left">
        <div class="con">
          <div class="title">
            <!-- <img v-lazy="$cdnStatic(`/fc/pc/loliya-logo 200_200.png`)" alt="" /> -->
            <img src="./images2/web_qqclogo.png" alt="" />
          </div>
          <div class="title2">
            <!-- <img src="./images2/web_wenz01.png" alt="" /> -->
            <van-swipe
              class="my-swipe"
              :autoplay="3000"
              :show-indicators="false"
            >
              <van-swipe-item>
                <img src="./images2/web_wenz01.png" alt="" />
                <!-- <img v-lazy="$cdnStatic(`/fc/pc/title1.png`)" /> -->
              </van-swipe-item>
              <van-swipe-item>
                <img src="./images2/web_wenz02.png" alt="" />
                <!-- <img v-lazy="$cdnStatic(`/fc/pc/title2.png`)" /> -->
              </van-swipe-item>
              <van-swipe-item>
                <img src="./images2/web_wenz03.png" alt="" />
                <!-- <img v-lazy="$cdnStatic(`/fc/pc/title3.png`)" /> -->
              </van-swipe-item>
            </van-swipe>
          </div>
          <div class="download">
            <div class="download-btn">
              <div class="android-btn" @click="showToast">
                <!-- <img v-lazy="$cdnStatic(`/lly/pc/images2/web_anzxz_btn.png`)" /> -->
                <img src="./images2/web_anzxz_btn.png" alt="" />
                <!-- <p>安卓下载</p> -->
              </div>
              <div class="android-btn" @click="showToast">
                <!-- <img v-lazy="$cdnStatic(`/lly/pc/images2/web_iosxz_btn.png`)" /> -->
                <img src="./images2/web_iosxz_btn.png" alt="" />
                <!-- <p>iOS下载</p> -->
              </div>
            </div>
            <div class="qr">
              <div ref="qrcodeTop" id="qrcode"></div>
              <!-- <img src="./images2/web_ts_xz.png" alt="" /> -->
              <!-- <img v-lazy="$cdnStatic(`/lly/pc/images2/web_ts_xz.png`)" /> -->
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <van-swipe class="my-swipe-1" :autoplay="3000">
          <van-swipe-item>
            <!-- <img src="./images2/web_r01.png" alt="" /> -->
            <img v-lazy="$cdnStatic(`/hb/pc/web_r01.png`)" />
          </van-swipe-item>
          <van-swipe-item>
            <!-- <img src="./images2/web_r02.png" alt="" /> -->
            <img v-lazy="$cdnStatic(`/hb/pc/web_r02.png`)" />
          </van-swipe-item>
          <van-swipe-item>
            <!-- <img src="./images2/web_r03.png" alt="" /> -->
            <img v-lazy="$cdnStatic(`/hb/pc/web_r03.png`)" />
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="toasta" v-show="isShowToast">请使用手机扫一扫下载</div>
    <div class="service">
      <span class="sptxt">客服</span>
      <span @click="goServe"
        ><img v-lazy="$cdnStatic(`/lly/pc/images2/zmy_cweb_cus icon@3x.png`)"
      /></span>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      isShowToast: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.createQrcode();
    });
    // 埋点
    this.$sensors.track("LandingPage", {
      method: "view",
      ldy_type: "PC",
    });
  },
  mounted() {
    var _paq = window._paq = window._paq || [];
    let code = this.getUrlParam("code");
    _paq.push(['setCustomDimension', 1, '6']);
    _paq.push(['setCustomDimension', 2, code]);
    _paq.push(['trackEvent',
      '框架加载',
      document.title,          //果酱...
      window.location.host]);
  },
  methods: {
    // 获取code参数
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    goServe() {
      window.location.href = "https://qqcfaq.com/huobao/servicemeiqia.html";
    },
    createQrcode() {
      const that = this;
      const url = window.location.href;
      new QRCode(that.$refs.qrcodeTop, {
        text: url,
        width: 249,
        height: 245,
        colorDark: "#000000",
        colorLight: "#ffffff",
      });
    },
    showToast() {
      this.isShowToast = true;
      setTimeout(() => {
        this.isShowToast = false;
      }, 3000);
      // this.$toast({
      //   message: '请使用手机扫一扫下载',
      //   position: 'top',
      // });
      this.$sensors.track("LandingPage", {
        method: "download",
        ldy_type: "PC",
        pid: "A85",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.van-swipe__indicator) {
  width: 180px;
  height: 6px;
  border-radius: 2px;
  mix-blend-mode: normal;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(30, 30, 30, 1);
  margin-left: 5px;
}
:deep(.van-swipe__indicator--active) {
  background: rgba(255, 255, 255, 1);
}
:deep(.van-swipe__indicators) {
  position: absolute;
  top: 90vh;
  //   left: 75%;
}
.main {
  width: 100%;
  overflow-x: hidden;
  min-height: 100vh;
  background: url("./images2/web_dbg.png") no-repeat;
  background-size: cover;
  height: auto;
  .service {
    width: 200px;
    // height: 40px;
    position: absolute;
    z-index: 9999;
    bottom: 0;
    top: 55px;
    left: 85%;
    right: 50%;
    text-align: center;
    color: #fff;
    font-family: "Microsoft YaHei";
    font-style: normal;
    font-weight: 700;
    font-size: 34px;
    line-height: 60px;
    vertical-align: middle;
    .sptxt {
      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
    img {
      width: 70px;
      margin-left: 16px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .toasta {
    width: 200px;
    height: 40px;
    position: absolute;
    z-index: 9999;
    bottom: 0;
    top: 50%;
    left: 45%;
    right: 50%;
    background-color: #ffffff;
    text-align: center;
    line-height: 40px;
    color: #0e0d0d;
    font-weight: 700;
    border-radius: 5px;
  }
  .content {
    // width: 100%;
    // height: 100%;
    display: flex;
    .left {
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.4);
      //   display: flex;
      //   flex: 1;
      .con {
        margin: auto;
      }
      .title {
        margin-bottom: 12px;
        // padding-top: 64px;
        > img {
          width: 456px;
          //   height: 200px;
          margin: 0 auto;
        }
      }
      .title2 {
        width: 754px;
        height: 80px;
        margin: 0 auto;
        img {
          // width: 100%;
          // height: 100%;
          max-width: 100%;
          margin: 0 auto;
          // height: 55px;
        }
      }
      .download {
        display: flex;
        // justify-content:space-around;
        align-items: center;
        margin-top: 200px;
        .download-btn {
          margin-bottom: 15px;
        }
        .android-btn {
          width: 340px;
          // height: 122px;
          margin-top: 35px;
          margin-left: 80px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .qr {
          width: 260px;
          height: 300px;
          background-color: #ffffff;
          border-radius: 20px;
          background: url("./images2/web_wemxz_bg.png") no-repeat;
          background-size: cover;
          padding: 25px 18px 25px 25px;
          color: #8c8788;
          text-align: center;
          margin-left: 55px;
          img {
            width: 250px;
            margin-top: 5px;
            font-size: 18px;
            color: #292023;
          }
        }
      }

      @media screen and (max-width: 1600px) {
        .title {
          margin-bottom: 12px;
          padding-top: 14px;
          > img {
            width: 456px;
            // height: 150px;
            margin: 0 auto;
          }
        }
        .title2 {
          width: 754px;
          height: 60px;
          margin: 0 auto;
          img {
            // width: 100%;
            // height: 100%;
            max-width: 100%;
            margin: 0 auto;
            // height: 55px;
          }
        }
        .download {
          display: flex;
          // justify-content:space-around;
          align-items: center;
          margin-top: 220px;
          .download-btn {
            // margin-bottom: 15px;
          }
          .android-btn {
            width: 340px;
            // height: 122px;
            margin-top: 35px;
            margin-left: 80px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .qr {
            width: 260px;
            height: 300px;
            background-color: #ffffff;
            border-radius: 20px;
            background: url("./images2/web_wemxz_bg.png") no-repeat;
            background-size: cover;
            padding: 25px 18px 25px 25px;
            color: #8c8788;
            text-align: center;
            margin-left: 55px;
            img {
              width: 250px;
              margin-top: 5px;
              font-size: 18px;
              color: #292023;
            }
          }
        }
      }
    }
    .right {
      height: 100vh;
         flex: 1;
      width: 1022px;
      //   width: 100%;
      position: relative;
    }
    .my-swipe-1 {
      width: 100%;
      height: 100vh;
      img {
        width: 80%;
        margin: 0 auto;
        padding-top: 100px;
      }
    }
  }
}
</style>
